import { Injectable } from '@angular/core';
import { TranslateLoader } from '@ngx-translate/core';
import { Observable } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class CustomTranslateLoader implements TranslateLoader {

    public getTranslation(lang: string): Observable<any> {
        return Observable.create((observer: any) => {
            const item: string = localStorage.getItem(`${lang}_merged_${document.title}`);
            let responseObj: any;
            if (item != null) {
                responseObj = JSON.parse(item);
            } else {
                responseObj = this.loadFallbackLanguage();
            }

            observer.next(responseObj);
            observer.complete();
        });
    }

    private loadFallbackLanguage(): any {
        const itemEn: string = localStorage.getItem(`en_merged_${document.title}`);

        if (itemEn === undefined || itemEn === null) {
            return {};
        }

        return JSON.parse(itemEn);
    }

}
